import { useHistory, useLocation } from 'react-router';
import { useAppSelector } from '../../effects/useAppSelector';
import { LocationState, LocationStateBuilder, PanelType } from '../../types/state/ui/LocationState';
import { RightSidePanel } from '../controls/RightSidePanel';
import { EditLoanForm } from './EditLoanForm';

export function LoanMonitorSidePanel() {
    const history = useHistory();
    const locationState = useLocation<LocationState<{ loanId: number }>>().state;
    const activeLoanId = locationState?.panel?.payload?.loanId;
    const loan = useAppSelector(s => activeLoanId ? s.loan.loans.find(l => l.id === activeLoanId) : null);

    if (locationState?.panel?.type !== PanelType.LoanMonitorSidePanel || !loan) {
        return null;
    }

    const handleClose = () => history.replace({
        ...history.location,
        state: new LocationStateBuilder(locationState).resetPanel().result(),
    });

    const renderTitle = () => {
        return loan.issuerName
    }

    return (
        <RightSidePanel
            className="load-monitor-right-side-panel"
            title={renderTitle()}
            onClose={handleClose}
        >
            <EditLoanForm loan={loan} onCancel={handleClose} />
        </RightSidePanel>
    );
}
